<template>
  <group 
    key-prefix="circle"
    :config="{...config, draggable}"
    @mouse:over="$emit('mouse:over')"
    @mouse:out="$emit('mouse:out')"
    @mouse:down="$emit('mouse:down')"
    @mouse:up="$emit('mouse:up')"
  >
    <v-circle 
      :key="`shape-circle-${name}`"
      :config="circleConfig"
    />
    <template v-if="!hideLabel">
      <slot>
        <Label
          v-bind="labelBackgroundProps"
          :config="labelConfig"
          :scale="labelScale"
          :background-color="labelBackgroundColor"
        />
      </slot>
    </template>
  </group>
</template>

<script>
import withLabel from './mixins/withLabel'
import basicShape from './mixins/basicShape'
import Group from './Group'
export default {
  name: 'DrawCircle',
  components: {Group},
  mixins: [withLabel, basicShape],
  data () {
    return {}
  },
  computed: {
    // Circles draw from center, but other shapes draw from top-left corner
    circleConfig () {
      const {offsetX, offsetY} = this.shapeConfig
      if (offsetX || offsetY) return this.shapeConfig
      return {...this.shapeConfig, offset: null} 
    }
  }
}
</script>